module.exports = __webpack_public_path__ + "img/thumbnail_AsianSmallClawedOtter_j_albino.7b4ae9b2.png";